import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-form-input--file', 'InputFile', InputFile)

function InputFile(component) {
  const input = component.element
  const form = input.closest('form')
  const maxSizeBytes = parseInt(input.dataset.maxFileSize)

  if (!maxSizeBytes) return

  component.useHandler(() => {
    const handleFileChange = (event) => {
      const file = input.files[0]
      
      if (file && file.size > maxSizeBytes) {
        const maxSizeMB = Math.round(maxSizeBytes / 1024 / 1024)
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(1)
        window.alert(`File size (${fileSizeMB}MB) exceeds the maximum allowed size of ${maxSizeMB}MB. Please choose a smaller file.`)
        
        // Clear the input
        input.value = ''
      }
    }

    input.addEventListener('change', handleFileChange)
    
    return () => input.removeEventListener('change', handleFileChange)
  })
}
